<div class="container-feedback w-100 h-100">
  <header>
    <nav class="navbar">
      <div class="navbar-content">
        <div class="background-container w-100">
          <img src="assets/images/backgrounds/background_header_2.png" class="background-header" alt="monex">
          <div class="user-info-container">
            <div class="logo-container">
              <img src="assets/images/icons/monex_login_icon.svg" class="logo-img" alt="monex-icon"><br>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
  <ng-container *ngIf="chargedForm">
      <ng-container *ngIf="isValidToken; else isInvalidToken">
          <div class="container-fluid">
            <div class="page-content">
                <div class="container-form">
                    <div class="feedback-container w-200">
                        <div class="title-container mb-3">
                            <div class="title">{{"Cuéntanos como te fue" | translate}}</div>
                        </div>
                        <form [formGroup]="feedbackForm">
                            <div class="title-container mb-3">
                                <div class="fb-label1">{{"feedbackQuestion1" | translate}}</div>
                            </div>
                            <div class="title-container mb-3">
                                <div class="sliderticks">
                                    <span>{{"fbOption1" | translate}}</span>
                                    <span class="fbOption2">{{"fbOption2" | translate}}</span>
                                    <span>{{"fbOption3" | translate}}</span>
                                </div>
                                <input
                                    type="range"
                                    min="0"
                                    max="100"
                                    value="0"
                                    id="range"
                                    step="50"
                                    formControlName="experience"
                                    (input)="setValueExperience($event)"
                                />
                            </div>
                            <div class="title-container mb-3">
                                <div class="fb-label1">{{"feedbackQuestion2" | translate}}</div>
                            </div>
                            <div class="title-container mb-3">
                                <div class="sliderticks">
                                    <span>{{"fbOption1" | translate}}</span>
                                    <span class="fbOption2">{{"fbOption2" | translate}}</span>
                                    <span>{{"fbOption3" | translate}}</span>
                                </div>
                                <input
                                    type="range"
                                    min="0"
                                    max="100"
                                    value="0"
                                    id="range"
                                    step="50"
                                    formControlName="design"
                                    (input)="setValueDesing($event)"
                                />
                            </div>
                            <div class="title-container mb-3">
                                <div class="fb-label1">{{"feedbackQuestion3" | translate}}</div>
                            </div>
                            <div class="title-container mb-3">
                                <textarea formControlName="feedbackInput" class="feedbackInput" placeholder="{{'phFeedbackInput' | translate}}"></textarea>
                            </div>
                            <div>
                                <button type="button" class="btn btn-banca-digital" (click)="setFeedback()">
                                    <span>{{"Enviar respuestas" | translate}}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
          </div>
      </ng-container>
      <ng-template #isInvalidToken>
          <div class="container-fluid" style="max-width: max-content; text-align: center;">
              <div class="page-content" style="width: 700px; text-align: center; padding-right: 40px; padding-bottom: 40px;">
                  <div class="mt-4 mb-4">
                      <img class="icon" src="assets/images/icons/error-process.png">
                  </div>
                  <p class="label-modal" style="text-align: center;">{{'Por cuestiones de seguridad la liga para restablecer tu contraseña ha expirado.' | translate}}</p>
              </div>
          </div>
      </ng-template>
  </ng-container>
</div>